/**
 * Catalyst's link component, wired to Inertia so links navigate without a full
 * page load. (See Catalyst's docs on client-side router integration.)
 */

import * as Headless from '@headlessui/react'
import { Link as InertiaLink } from '@inertiajs/react'
import React, { forwardRef } from 'react'

export const Link = forwardRef(function Link(
  props: { href: string } & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  return (
    <Headless.DataInteractive>
      <InertiaLink {...(props as React.ComponentProps<typeof InertiaLink>)} ref={ref} />
    </Headless.DataInteractive>
  )
})
